export const TRANSACTION_LIST = 'TransactionList'
export const TRANSACTION_DETAILS = 'TransactionDetails'
export const TRANSACTION = 'Transaction'
